/**
 * 工具类
 */
import request from '@/assets/scripts/utils/request';

// 获取上传科界七牛token（注意是科界 主要是用户头像和科创圈）
export function getSciMallQiNiuToken() {
    return request({
        url: '/upload/getkjqntoken',
        method: 'get'
    });
}

// 获取七牛 token 获取上传科创中国七牛token（注意是科创中国）
export function getQiNiuToken() {
    return request({
        url: '/upload/getqntoken',
        method: 'get'
    });
}
